import React from 'react';
import { useLanguage } from '../i18n';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { copy } = useLanguage();

  return (
    <footer className="bg-muted/30 border-t border-border">
      <div className="container mx-auto px-6 py-16">
        <div className="flex flex-col items-center justify-center text-center space-y-6 max-w-3xl mx-auto">
          <img 
            src={`${process.env.PUBLIC_URL}/images/antzone-logo.png`}
            alt="AntZone Logo"
            className="h-16 md:h-20 w-auto"
          />
          
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            {copy.footer.first} <br />
            <span className="text-orange-500 font-semibold">{copy.footer.second}</span>
            <span className="text-red-500 font-semibold">{copy.footer.third}</span>
            {copy.footer.fourth}
          </p>

          <div className="w-full max-w-md">
            <div className="h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent rounded-full"></div>
            <div className="mt-2 h-0.5 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
          </div>

          <p className="text-sm text-muted-foreground pt-4">
            © {currentYear} AntZone. {copy.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};
